import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.reports');
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/ggeea/service";

@Component({
    selector: 'wiz-page-admin-reports',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.reports/view.scss */
:host {
  display: block;
}

.report-page {
  min-height: 100vh;
  background: #f4f7fb;
  color: #111827;
}

.report-page__header,
.report-controls,
.report-band,
.report-panel,
.report-metric {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.report-page__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 20px;
  border-radius: 8px;
}

.report-page__title {
  margin: 0;
  font-size: 20px;
  line-height: 1.35;
  font-weight: 800;
  letter-spacing: 0;
}

.report-page__subtitle {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.report-page__download,
.report-controls__apply {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 800;
  transition: border-color 0.16s ease, background 0.16s ease, color 0.16s ease;
}

.report-page__download {
  min-width: 132px;
  border: 1px solid #059669;
  background: #059669;
  color: #ffffff;
}

.report-page__download:hover:not(:disabled) {
  background: #047857;
  border-color: #047857;
}

.report-page__download:disabled,
.report-controls__apply:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.report-controls {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) 180px 180px auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 18px;
  padding: 16px;
  border-radius: 8px;
}

.report-controls__types {
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.report-type {
  min-width: 0;
  min-height: 70px;
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #dbe4ee;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  text-align: left;
  transition: border-color 0.16s ease, background 0.16s ease, color 0.16s ease;
}

.report-type i {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
}

.report-type span {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.report-type strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #111827;
  font-size: 12px;
  font-weight: 850;
}

.report-type em {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: #64748b;
  font-size: 11px;
  line-height: 1.35;
  font-style: normal;
  font-weight: 700;
}

.report-type.is-active {
  border-color: #10b981;
  background: #ecfdf5;
}

.report-type.is-active i {
  background: #059669;
  color: #ffffff;
}

.report-type:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.report-controls__presets {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.report-controls__preset {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid #dbe4ee;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}

.report-controls__preset.is-active {
  border-color: #10b981;
  background: #ecfdf5;
  color: #047857;
}

.report-controls__field {
  display: grid;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  color: #475569;
}

.report-controls__field input {
  width: 100%;
  min-height: 38px;
  padding: 0 10px;
  border: 1px solid #dbe4ee;
  border-radius: 8px;
  background: #ffffff;
  color: #111827;
  font-size: 13px;
}

.report-controls__apply {
  min-width: 92px;
  border: 1px solid #cbd5e1;
  background: #111827;
  color: #ffffff;
}

.report-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
  padding: 12px 14px;
  border: 1px solid #fde68a;
  border-radius: 8px;
  background: #fffbeb;
  color: #92400e;
  font-size: 13px;
  font-weight: 700;
}

.report-loading {
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.report-preview {
  display: grid;
  gap: 18px;
}

.report-band {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 8px;
}

.report-band__label {
  font-size: 12px;
  font-weight: 800;
  color: #059669;
}

.report-band__title {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 850;
  color: #111827;
}

.report-band__description {
  margin-top: 4px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 700;
}

.report-band__meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.report-band__meta span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  padding: 0 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}

.report-metrics {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 10px;
}

.report-metric {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-height: 104px;
  padding: 14px;
  border-radius: 8px;
}

.report-metric__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0f172a;
}

.report-metric__icon.is-zinc {
  background: #f1f5f9;
}

.report-metric__icon.is-sky {
  background: #e0f2fe;
  color: #0369a1;
}

.report-metric__icon.is-emerald {
  background: #dcfce7;
  color: #047857;
}

.report-metric__icon.is-rose {
  background: #ffe4e6;
  color: #be123c;
}

.report-metric__icon.is-violet {
  background: #ede9fe;
  color: #6d28d9;
}

.report-metric__icon.is-amber {
  background: #fef3c7;
  color: #b45309;
}

.report-metric__label {
  font-size: 12px;
  font-weight: 800;
  color: #64748b;
}

.report-metric__value {
  margin-top: 3px;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 900;
  color: #111827;
}

.report-metric__caption {
  margin-top: 3px;
  font-size: 11px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.report-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.report-panel {
  border-radius: 8px;
  padding: 18px;
}

.report-panel--wide,
.report-panel--table {
  grid-column: 1/-1;
}

.report-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.report-panel__title {
  font-size: 15px;
  font-weight: 850;
  color: #111827;
}

.report-panel__caption {
  margin-top: 4px;
  font-size: 12px;
  color: #64748b;
}

.report-list {
  display: grid;
  gap: 10px;
}

.report-list__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 40px;
  border-bottom: 1px solid #eef2f7;
  font-size: 13px;
}

.report-list__row:last-child {
  border-bottom: 0;
}

.report-list__row span {
  color: #64748b;
  font-weight: 700;
}

.report-list__row strong {
  color: #111827;
  font-weight: 850;
}

.report-keywords {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.report-keyword {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f8fafc;
}

.report-keyword span {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #111827;
  color: #ffffff;
  font-size: 11px;
  font-weight: 900;
}

.report-keyword strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #111827;
}

.report-keyword em {
  font-style: normal;
  font-size: 12px;
  font-weight: 800;
  color: #059669;
}

.report-empty {
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 700;
}

.report-table-wrap {
  overflow-x: auto;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 720px;
  font-size: 12px;
}

.report-table th,
.report-table td {
  height: 38px;
  border-bottom: 1px solid #eef2f7;
  padding: 0 10px;
  text-align: right;
  white-space: nowrap;
}

.report-table th:first-child,
.report-table td:first-child {
  text-align: left;
}

.report-table th {
  background: #f8fafc;
  color: #475569;
  font-weight: 850;
}

.report-table td {
  color: #334155;
  font-weight: 700;
}

.report-actions {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 8px;
}

.report-actions li {
  position: relative;
  padding-left: 18px;
  color: #334155;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 700;
}

.report-actions li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #10b981;
}

@media (max-width: 1280px) {
  .report-metrics {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .report-keywords {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .report-controls__types {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 900px) {
  .report-page {
    padding: 18px;
  }
  .report-page__header,
  .report-band {
    flex-direction: column;
  }
  .report-controls {
    grid-template-columns: 1fr;
  }
  .report-metrics,
  .report-grid,
  .report-keywords,
  .report-controls__types {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageAdminReportsComponent implements OnInit {
    public reportTypes = [
        {
            id: 'comprehensive',
            label: '종합 운영보고서',
            description: '전체 KPI·품질·지식관리·키워드·추이',
            title: '기후아이 챗봇 운영보고서',
            filename: 'operational-report',
            icon: 'fa-file-lines',
        },
        {
            id: 'quality',
            label: '답변 품질 보고서',
            description: '답변률·응답 유형·피드백·부정 사유',
            title: '기후아이 챗봇 답변 품질 보고서',
            filename: 'answer-quality-report',
            icon: 'fa-circle-check',
        },
        {
            id: 'knowledge',
            label: '지식관리 보고서',
            description: 'RAG 문서·인덱싱·크롤링·수집 현황',
            title: '기후아이 챗봇 지식관리 보고서',
            filename: 'knowledge-management-report',
            icon: 'fa-database',
        },
        {
            id: 'trend',
            label: '질의 트렌드 보고서',
            description: '주요 키워드·반복 질문·FAQ 후보',
            title: '기후아이 챗봇 질의 트렌드 보고서',
            filename: 'query-trend-report',
            icon: 'fa-chart-line',
        },
        {
            id: 'improvement',
            label: '운영 개선 보고서',
            description: '오류·실패 지표와 개선 조치 후보',
            title: '기후아이 챗봇 운영 개선 보고서',
            filename: 'operation-improvement-report',
            icon: 'fa-screwdriver-wrench',
        },
    ];
    public presets = [
        { id: 'today', label: '오늘' },
        { id: '7d', label: '최근 7일' },
        { id: '30d', label: '최근 30일' },
        { id: 'thisMonth', label: '이번 달' },
    ];
    public reportType: string = 'comprehensive';
    public preset: string = '30d';
    public startDate: string = '';
    public endDate: string = '';
    public report: any = null;
    public metricCards: any[] = [];
    public loaded: boolean = false;
    public loading: boolean = false;
    public downloading: boolean = false;
    public error: string = '';

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.service.bindCdr(this.cdr);
        this.setPresetRange('30d');
        await this.load();
    }

    public async changePreset(preset: string) {
        this.setPresetRange(preset);
        await this.load();
    }

    public markCustom() {
        this.preset = 'custom';
    }

    public async changeReportType(reportType: string) {
        if (this.reportType === reportType) return;
        this.reportType = reportType || 'comprehensive';
        await this.load();
    }

    public async load() {
        if (!this.startDate || !this.endDate) {
            this.error = '보고 기간을 선택해 주세요.';
            await this.service.render();
            return;
        }
        if (this.startDate > this.endDate) {
            const temp = this.startDate;
            this.startDate = this.endDate;
            this.endDate = temp;
        }
        this.loading = true;
        this.loaded = false;
        this.error = '';
        await this.service.render();
        try {
            const report = await this.service.apiHarness('reports', 'summary', {
                start_date: this.startDate,
                end_date: this.endDate,
                report_type: this.reportType,
                mode: 'preview',
            }, { cacheTtlMs: 30000, timeoutMs: 15000 });
            this.report = report || {};
            this.reportType = this.report?.report_type || this.reportType || 'comprehensive';
            this.metricCards = this.buildMetricCards();
        } catch (e: any) {
            this.error = e?.message || String(e);
            this.report = null;
            this.metricCards = [];
        }
        this.loading = false;
        this.loaded = true;
        await this.service.render();
    }

    public async downloadHwpx() {
        if (this.downloading || this.loading) return;
        if (!this.startDate || !this.endDate) {
            this.service.alert('보고 기간을 선택해 주세요.');
            return;
        }
        this.downloading = true;
        await this.service.render();
        try {
            const form = new FormData();
            form.append('start_date', this.startDate);
            form.append('end_date', this.endDate);
            form.append('report_type', this.reportType);
            const res = await fetch('/api/ggeea/admin/reports/hwpx', {
                method: 'POST',
                body: form,
                credentials: 'include',
            });
            const contentType = res.headers.get('Content-Type') || '';
            if (!res.ok || contentType.includes('application/json')) {
                const body = await res.json().catch(() => ({}));
                throw new Error(body?.data?.message || body?.message || `운영보고서 생성 실패 (${res.status})`);
            }
            const blob = await res.blob();
            if (!blob.size) {
                throw new Error('운영보고서 파일이 비어 있습니다.');
            }
            const filename = this.downloadFilename(res.headers.get('Content-Disposition'));
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (e: any) {
            this.service.alert(e?.message || String(e));
        }
        this.downloading = false;
        await this.service.render();
    }

    public keywordRows(): any[] {
        return Array.isArray(this.report?.keywords) ? this.report.keywords.slice(0, 8) : [];
    }

    public dailyRows(): any[] {
        const rows = Array.isArray(this.report?.daily) ? this.report.daily : [];
        return rows.slice(Math.max(rows.length - 14, 0));
    }

    public recommendations(): string[] {
        return Array.isArray(this.report?.recommendations) ? this.report.recommendations : [];
    }

    public selectedReportType(): any {
        return this.reportTypes.find((row) => row.id === this.reportType) || this.reportTypes[0];
    }

    public selectedReportTitle(): string {
        return this.report?.title || this.selectedReportType()?.title || '기후아이 챗봇 운영보고서';
    }

    public formatNumber(value: any): string {
        if (value === null || value === undefined || value === '') return '-';
        return new Intl.NumberFormat('ko-KR').format(Number(value || 0));
    }

    public formatPct(value: any): string {
        return `${Number(value || 0).toFixed(1)}%`;
    }

    public formatMs(value: any): string {
        const ms = Number(value || 0);
        if (!ms) return '-';
        return `${(ms / 1000).toFixed(1)}초`;
    }

    public trackPreset = (_: number, row: any) => row?.id || _;
    public trackReportType = (_: number, row: any) => row?.id || _;
    public trackMetric = (_: number, row: any) => row?.label || _;
    public trackKeyword = (_: number, row: any) => row?.keyword || _;
    public trackDaily = (_: number, row: any) => row?.date || _;
    public trackText = (_: number, text: string) => text || _;

    private setPresetRange(preset: string) {
        this.preset = preset;
        const end = new Date();
        end.setHours(12, 0, 0, 0);
        let start = new Date(end.getTime());
        if (preset === 'today') start = new Date(end.getTime());
        else if (preset === '7d') start.setDate(end.getDate() - 6);
        else if (preset === '30d') start.setDate(end.getDate() - 29);
        else if (preset === 'thisMonth') start = new Date(end.getFullYear(), end.getMonth(), 1, 12, 0, 0, 0);
        this.startDate = this.formatDateInput(start);
        this.endDate = this.formatDateInput(end);
    }

    private formatDateInput(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private buildMetricCards(): any[] {
        const kpi = this.report?.kpi || {};
        const feedback = this.report?.feedback || {};
        const rag = this.report?.rag || {};
        const crawl = this.report?.crawl || {};
        return [
            { label: '대화 세션', value: `${this.formatNumber(kpi.total_visit)}건`, caption: '기간 내 대화 세션', icon: 'fa-comments', tone: 'is-zinc' },
            { label: '질문 수', value: `${this.formatNumber(kpi.total_q)}건`, caption: '사용자 질문 기준', icon: 'fa-circle-question', tone: 'is-sky' },
            { label: '답변률', value: this.formatPct(kpi.answer_rate), caption: `평균 응답 ${this.formatMs(kpi.avg_ttft_ms)}`, icon: 'fa-chart-pie', tone: 'is-emerald' },
            { label: '부정 피드백', value: `${this.formatNumber(feedback.negative)}건`, caption: `피드백률 ${this.formatPct(feedback.feedback_rate)}`, icon: 'fa-thumbs-down', tone: 'is-rose' },
            { label: 'RAG 문서', value: `${this.formatNumber(rag.total)}건`, caption: `신규 ${this.formatNumber(rag.created_in_period)}건`, icon: 'fa-file-lines', tone: 'is-violet' },
            { label: '크롤링 작업', value: `${this.formatNumber(crawl.total_jobs)}건`, caption: `실패 ${this.formatNumber(crawl.failed)}건`, icon: 'fa-database', tone: 'is-amber' },
        ];
    }

    private downloadFilename(disposition: string | null): string {
        const slug = this.selectedReportType()?.filename || 'operational-report';
        const fallback = `ggeea-${slug}-${this.startDate.replace(/-/g, '')}-${this.endDate.replace(/-/g, '')}.hwpx`;
        if (!disposition) return fallback;
        const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (encoded && encoded[1]) {
            try { return decodeURIComponent(encoded[1]); } catch (e) { }
        }
        const plain = disposition.match(/filename="?([^";]+)"?/i);
        return plain?.[1] || fallback;
    }
}

export default PageAdminReportsComponent;